import { MotionReveal } from "../components/MotionReveal";
import { Link } from "react-router-dom";

const insights = [
  {
    category: "AIOps Perspectives",
    title: "From alerts to decisions: the executive model for AIOps",
    excerpt: "Why correlation, context, and automation outperform more dashboards.",
    readTime: "6 min",
    date: "2025-12-15",
  },
  {
    category: "SRE & Reliability",
    title: "SLIs and SLOs for leaders: what to measure and why it matters",
    excerpt: "A practical framework to link reliability metrics to business outcomes.",
    readTime: "7 min",
    date: "2025-12-15",
  },
  {
    category: "Industry Insights",
    title: "Government observability: resilience, auditability, and continuity",
    excerpt: "Patterns for hybrid estates, citizen services, and compliance.",
    readTime: "5 min",
    date: "2025-12-15",
  },
  {
    category: "Technology Deep Dives",
    title: "Best-of-breed telemetry: how to unify signals without vendor lock-in",
    excerpt: "A layered architecture approach that keeps your outcomes portable.",
    readTime: "8 min",
    date: "2025-12-15",
  },
];

export default function InsightsPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="pt-6 sm:pt-10">
        <MotionReveal>
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs uppercase tracking-[0.18em] text-[var(--text-secondary)]">
              Resources & perspectives
            </div>
            <h1 className="mt-6 font-[var(--font-display)] text-4xl sm:text-5xl tracking-tight text-white">Insights</h1>
            <p className="mt-4 max-w-3xl text-sm sm:text-base text-[var(--text-secondary)]">
              Executive-grade guidance across AIOps, SRE, industry use cases, and technology strategy.
            </p>
          </div>
        </MotionReveal>
      </div>

      <section className="mt-10 sm:mt-14">
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {insights.map((i, idx) => (
            <MotionReveal key={i.title} delay={Math.min(0.35, idx * 0.05)}>
              <Link to="/insights" className="glass-panel hover-lift block rounded-3xl p-6">
                <div className="inline-flex rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-[var(--text-secondary)]">
                  {i.category}
                </div>
                <div className="mt-4 font-[var(--font-display)] text-xl tracking-tight text-white">{i.title}</div>
                <div className="mt-3 text-sm text-[var(--text-secondary)]">{i.excerpt}</div>
                <div className="mt-6 flex items-center justify-between text-xs text-[var(--text-secondary)] font-[var(--font-mono)]">
                  <span>{i.readTime}</span>
                  <span>{i.date}</span>
                </div>
              </Link>
            </MotionReveal>
          ))}
        </div>
      </section>

      <div className="h-12" />
    </div>
  );
}
